// extracted by mini-css-extract-plugin
export default {"scriptPane":"ConnectBizon_scriptPane__rJN6Q","copyButton":"ConnectBizon_copyButton__z88rN"};